import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 51" {...this.props}><title>No items found</title><circle cx="21" cy="21" r="18" fill="none" strokeWidth="4" stroke="currentColor" /><path stroke="currentColor" strokeWidth="4" d="M33.5 34.8l13.7 13.6M29.1 12.9L12.9 29.1m0-16.2l16.2 16.2" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/emptystate-nothing-found.inline.svg